// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__iuSnl","tagButton":"styles_tagButton__12Zv4","icon":"styles_icon__OqKis","label":"styles_label__y2f8v"};